import { useState } from "react";
import {
  Box, Typography, MenuItem, Select, Card, CardContent, Button, Divider
} from "@mui/material";
import mockData from "../../mocks/equipo_evaluaciones.json";
import EvaluationDetailModal from "./EvaluationDetailModal";

// Mapeo invertido según SuggestedFeedbackSection
const scoreToQualitativeMap = {
  5: "1 - Excede ampliamente las expectativas",
  4: "2 - Desempeño por encima del esperado",
  3: "3 - Desempeño esperado",
  2: "4 - Desempeño por debajo del esperado",
  1: "5 - Bastante alejado del esperado"
};

export default function TeamEvaluations() {
  const [selectedLegajo, setSelectedLegajo] = useState(mockData.empleados[0]?.legajo || "");
  const [selectedEvaluation, setSelectedEvaluation] = useState(null);
  const empleado = mockData.empleados.find(e => e.legajo === selectedLegajo);
  const evaluations = mockData.evaluaciones.filter(ev => ev.legajo === selectedLegajo);

  return (
    <Box p={4} maxWidth="900px" mx="auto">
      <Typography variant="h4" mb={4}>Evaluaciones de mi equipo</Typography>
      <Box mb={3}>
        <Typography variant="subtitle1" mb={1}>Seleccioná un colaborador:</Typography>
        <Select
          value={selectedLegajo}
          onChange={e => setSelectedLegajo(e.target.value)}
          sx={{ minWidth: 250 }}
        >
          {mockData.empleados.map(emp => (
            <MenuItem key={emp.legajo} value={emp.legajo}>
              {emp.nombre} — {emp.puesto}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Divider sx={{ mb: 3 }} />
      <Typography variant="h6" mb={2}>
        Evaluaciones de {empleado?.nombre}
      </Typography>
      <Box display="flex" flexDirection="column" gap={3}>
        {evaluations.length === 0 && (
          <Typography>No hay evaluaciones para este colaborador.</Typography>
        )}
        {evaluations.map(evaluation => (
          <Card key={evaluation.id} variant="outlined">
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6" color="primary">
                  Período: {evaluation.period}
                </Typography>
                <Typography 
                  variant="subtitle1" 
                  sx={{
                    bgcolor: 'primary.50',
                    color: 'primary.main',
                    py: 0.5,
                    px: 2,
                    borderRadius: 1
                  }}
                >
                  {scoreToQualitativeMap[evaluation.score] || "No disponible"}
                </Typography>
              </Box>
              <Divider sx={{ my: 2 }} />
              <Box mb={2}>
                <Typography variant="subtitle1" fontWeight="bold" color="primary.dark" gutterBottom>
                  Fortalezas
                </Typography>
                <Typography variant="body1" whiteSpace="pre-line" sx={{ pl: 2 }}>
                  {evaluation.strengths}
                </Typography>
              </Box>
              <Box mb={2}>
                <Typography variant="subtitle1" fontWeight="bold" color="primary.dark" gutterBottom>
                  Áreas de Mejora
                </Typography>
                <Typography variant="body1" whiteSpace="pre-line" sx={{ pl: 2 }}>
                  {evaluation.areasOfImprovement}
                </Typography>
              </Box>
              <Button variant="outlined" onClick={() => setSelectedEvaluation(evaluation)}>
                Ver detalle
              </Button>
            </CardContent>
          </Card>
        ))}
      </Box>
      <EvaluationDetailModal
        open={!!selectedEvaluation}
        onClose={() => setSelectedEvaluation(null)}
        evaluation={selectedEvaluation}
      />
    </Box>
  );
} 